import { useRef, useState, useCallback } from 'react';

type PopoverMenuHooks<T> = [React.MutableRefObject<T>, boolean, () => void, () => void]

/**
 * Creates the hooks necessary for the Popover Menu to function
 *
 * @returns {PopoverMenuHooks}
 */
const usePopoverMenu = (): PopoverMenuHooks<any> => {
  const [menuOpen, setMenuOpen] = useState(false);
  const anchorElementRef = useRef(null);

  const handleMenuOpen = useCallback(() => {
    setMenuOpen(true);
  }, []);
  const handleMenuClose = useCallback(() => {
    setMenuOpen(false);
  }, []);

  return [anchorElementRef, menuOpen, handleMenuOpen, handleMenuClose];
};

export default { usePopoverMenu };
